import { render, staticRenderFns } from "./downloadCard.vue?vue&type=template&id=2c934d26&scoped=true&"
import script from "./downloadCard.vue?vue&type=script&lang=js&"
export * from "./downloadCard.vue?vue&type=script&lang=js&"
import style0 from "./downloadCard.vue?vue&type=style&index=0&id=2c934d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c934d26",
  null
  
)

export default component.exports